import { AccountsService } from "@openmoney/proto/openmoney/accounts/v1";

import { useMutation } from "@connectrpc/connect-query";
import { useState } from "react";

export function CreateAccountForm() {
  const [name, setName] = useState("");
  const [balance, setBalance] = useState("0");

  const create = useMutation(AccountsService.method.create, {
    mutationKey: ["connect-query"],
    onSuccess: () => {
      setName("");
      setBalance("0");
    },
  });

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        create.mutate({ name, balance: Number(balance) });
      }}
      className="grid gap-3.5"
    >
      <div className="grid gap-3 grid-cols-[2fr_1fr]">
        <div>
          <label htmlFor="account-name">Account Name</label>
          <input
            id="account-name"
            type="text"
            placeholder="e.g., Checking, Savings"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="account-balance">Initial Balance</label>
          <input
            id="account-balance"
            type="number"
            placeholder="0.00"
            step="0.01"
            value={balance}
            onChange={(e) => setBalance(e.target.value)}
            required
          />
        </div>
      </div>
      <div className="flex gap-2.5 items-center">
        <button type="submit" disabled={create.isPending} className="primary">
          {create.isPending ? "Creating…" : "Create"}
        </button>
        {create.error && (
          <p className="text-[--green] m-0 text-[0.8125rem]">{create.error.message}</p>
        )}
      </div>
    </form>
  );
}
